import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import {
  imageCodes,
  textCodes,
  titleCodes,
} from "../../template_codes/willow/home_page_my_codes";
import logo from "../../assets/images/willow/willow_logo.jpg";

function HomeMy() {
  return (
    <div>
      {/*             header menu              */}
      <div class="navbar bg-base-100">
        <div class="flex-1">
          <Link to={paths.home}>
            <img src={logo} alt="logo" width={122} height={38} />
          </Link>
        </div>
        <div class="flex-none gap-2">
          <a href="https://willowlabelmm.com/" className="text-xl uppercase">
            {textCodes.myShopText.text}
          </a>
          <Link to={paths.home}>
            <p className="text-xl uppercase">{textCodes.eng.text}</p>
          </Link>
        </div>
      </div>
      {/*             header menu              */}

      {/*              slider section               */}
      <div class="carousel w-full pt-2 pb-10">
        <div id="slide1" class="carousel-item relative w-full">
          <img src={imageCodes.mySliderOne.image} class="w-full" />
          <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
            <a href="#slide2" class="btn btn-circle bg-[#d4c4b5] border-0">
              ❮
            </a>
            <a href="#slide2" class="btn btn-circle bg-[#d4c4b5] border-0">
              ❯
            </a>
          </div>
        </div>
        <div id="slide2" class="carousel-item relative w-full">
          <img src={imageCodes.mySliderTwo.image} class="w-full" />
          <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
            <a href="#slide1" class="btn btn-circle bg-[#d4c4b5] border-0">
              ❮
            </a>
            <a href="#slide1" class="btn btn-circle bg-[#d4c4b5] border-0">
              ❯
            </a>
          </div>
        </div>
      </div>
      {/*              slider section               */}

      {/*              category section              */}
      <div className="py-14">
                <h1 className="text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase pl-4 xl:pl-16 2xl:pl-20">{titleCodes.myOurProduct.title}</h1>

                <div class="carousel carousel-end rounded-box">
                    <div class="carousel-item p-4">
                        <div class="card w-96 bg-base-100 shadow-xl">
                            <figure><a href="https://willowlabelmm.com/"><img src={imageCodes.myFeature1.image} alt="Shoes" /></a></figure>
                            <div class="card-body">
                                <a href="https://willowlabelmm.com/">
                                    <h2 class="card-title pb-4">
                                        Woman
                                    </h2>
                                    <p>{textCodes.myWomenText.text}</p>
                                    <div class="card-actions justify-end pt-4">
                                        <div class="badge badge-outline">Woman</div>
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="carousel-item p-4">
                        <div class="card w-96 bg-base-100 shadow-xl">
                            <figure><a href="https://willowlabelmm.com/"><img src={imageCodes.feature2.image} alt="Shoes" /></a></figure>
                            <div class="card-body">
                                <a href="https://willowlabelmm.com/">
                                    <h2 class="card-title pb-4">
                                        Boy
                                    </h2>
                                    <p>{textCodes.myBoyText.text}</p>
                                    <div class="card-actions justify-end pt-4">
                                        <div class="badge badge-outline">Boy</div>
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="carousel-item p-4">
                        <div class="card w-96 bg-base-100 shadow-xl">
                            <figure><a href="https://willowlabelmm.com/"><img src={imageCodes.feature3.image} alt="Shoes" /></a></figure>
                            <div class="card-body">
                                <a href="https://willowlabelmm.com/">
                                    <h2 class="card-title pb-4">
                                        Girl
                                    </h2>
                                    <p>{textCodes.myGirlText.text}</p>
                                    <div class="card-actions justify-end pt-4">
                                        <div class="badge badge-outline">Girl</div>
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="carousel-item p-4">
                        <div class="card w-96 bg-base-100 shadow-xl">
                            <figure><a href="https://willowlabelmm.com/"><img src={imageCodes.myFeature1.image} alt="Shoes" /></a></figure>
                            <div class="card-body">
                                <a href="https://willowlabelmm.com/">
                                    <h2 class="card-title pb-4">
                                        Man
                                    </h2>
                                    <p>{textCodes.myWomenText.text}</p>
                                    <div class="card-actions justify-end pt-4">
                                        <div class="badge badge-outline">Man</div>
                                        <div class="badge badge-outline">Fashion</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
      {/*              end of category section              */}

      {/*              story section              */}

      <div className="container p-4 lg:p-8 xl:p-10 2xl:p-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-2">
          <div className="text-justify pt-8">
            <p className="text-xs lg:text-lg xl:text-lg pb-2 lowercase font-extralight">
              {titleCodes.myOurStory.title}
            </p>
            <h1 className="text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase pb-8">
              {titleCodes.myWhoTitle.title}
            </h1>
            <p className="tracking-wider pb-4">{textCodes.myStory1.text}</p>
            <p className="tracking-wider">{textCodes.myStory3.text}</p>
          </div>
          <div>
            <img src={imageCodes.myWhoWeAre.image} className="p-2"></img>
          </div>
        </div>
      </div>
      {/*              end of story section              */}

      {/*              story section 2              */}

      <div className="container p-4 lg:p-8 xl:p-10 2xl:p-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-2">
          <div>
            <img src={imageCodes.myWeDo.image} className="p-2"></img>
          </div>
          <div>
            <div className="text-justify pt-8">
              <p className="text-xs lg:text-lg xl:text-lg pb-2 lowercase font-extralight">
                {titleCodes.myOurStory.title}
              </p>
              <h1 className="text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase pb-8">
                {titleCodes.myDoTitle.title}
              </h1>
              <p className="tracking-wider pb-4">{textCodes.myWedo1.text}</p>
              <p className="tracking-wider">{textCodes.myWedo2.text}</p>
            </div>
          </div>
        </div>
      </div>
      {/*              end of story section 2             */}

      {/*              instagram photo section              */}
      <div className="container p-10">
        <div className="text-center">
          <h1 className="text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase pb-8">
            {titleCodes.myFeaturePhotos.title}
          </h1>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-3 pb-4">
          <div>
            <img src={imageCodes.myFeaturePhoto1.image}></img>
          </div>
          <div>
            <img src={imageCodes.myFeaturePhoto2.image}></img>
          </div>
          <div>
            <img src={imageCodes.myFeaturePhoto3.image}></img>
          </div>
          <div>
            <img src={imageCodes.myFeaturePhoto4.image}></img>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-3">
          <div>
            <img src={imageCodes.myFeaturePhoto5.image}></img>
          </div>
          <div>
            <img src={imageCodes.myFeaturePhoto6.image}></img>
          </div>
          <div>
            <img src={imageCodes.myFeaturePhoto7.image}></img>
          </div>
        </div>
      </div>
      {/*              end of instagram photo section              */}

      {/*              track order and media section              */}
      <div className="container p-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-8 pt-14">
          <div
            className="w-full bg-cover py-20 "
            style={{ backgroundImage: `url(${imageCodes.myTrackOrder.image})` }}
          >
            <div className="container w-56 lg:w-80 xl:w-80 2xl:w-80 text-center py-44">
              <a href="https://www.ninjavan.co/en-mm/tracking" target="_blank">
                <h1 className="bg-[#ffffff80] text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase py-4">
                  {titleCodes.myTrackYourOrder.title}
                </h1>
              </a>
            </div>
          </div>
          <div
            className="w-full bg-cover py-20 "
            style={{ backgroundImage: `url(${imageCodes.myMediaRoom.image})` }}
          >
            <div className="container w-56 lg:w-80 xl:w-80 2xl:w-80 text-center py-44">
              <Link to={paths.media}>
                <h1 className="bg-[#ffffff80] text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase py-4">
                  {titleCodes.myMediaRoomTitle.title}
                </h1>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/*              end of track order and media section              */}
    </div>
  );
}

export default HomeMy;
